<template>
    <div class="timetable-view-schedule">
        <b class="float-right">Total: {{ events.length }}</b>

        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="lesson-number">#</th>
                        <th>Data</th>
                        <th>Ora</th>
                        <th>Nume</th>
                        <th>Instructor</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="0 == orderedEvents.length">
                    <tr>
                        <th colspan="6">Nu există lecții planificate</th>
                    </tr>
                </tbody>
                <tbody>
                    <tr
                        v-for="(event, index) in orderedEvents"
                        @click.stop.prevent="
                            clickEvent(event, event._start_time)
                        "
                        v-bind:class="
                            lo.concat(
                                [event._start_time < now ? 'old' : ''],
                                event.custom_css_classes
                            )
                        "
                        v-bind:style="lo.merge({}, event.custom_css)"
                    >
                        <th class="lesson-number">{{ index + 1 }}</th>
                        <th>
                            {{
                                event._start_time
                                    | format_date("dddd, D MMMM YYYY")
                            }}
                        </th>
                        <td>
                            {{ event._start_time | format_time }} -
                            {{ event._end_time | format_time }}
                        </td>
                        <td>{{ event.display_title }}</td>
                        <td>
                            <span v-if="event.instructor_info">{{
                                event.instructor_info.full_name
                            }}</span>
                            <practice-lesson-price
                                v-if="event.instructor_info"
                                v-bind:info="event.instructor_info"
                            ></practice-lesson-price>
                        </td>
                        <td class="actions">
                            <button
                                v-if="
                                    (action === 'edit' ||
                                        action === 'schedule' ||
                                        action === 'show') &&
                                    canDeleteEvents &&
                                    !event.deleted_at
                                "
                                type="button"
                                class="text-white btn btn-danger btn-delete"
                                @click.stop="deleteEvent(event)"
                            >
                                <i class="icon-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import TimetableViewBase from "./TimetableView-Base.vue";
import PracticeLessonPrice from "./components/PracticeLessonPrice.vue";

export default {
    extends: TimetableViewBase,

    components: {
        "practice-lesson-price": PracticeLessonPrice,
    },

    props: {
        canDeleteEvents: {
            default: false,
        },
    },

    data() {
        return {
            view: "schedule",
        };
    },

    mounted() {
        console.log("Timetable View Schedule Component Mounted.");
    },

    methods: {
        deleteEvent(event) {
            this.eventBus.$emit("delete-event", event, event._start_time);
        },
    },
};
</script>
<style lang="scss">
.timetable > .timetable-view-schedule {
    min-height: 300px;
}

.timetable-view-schedule {
    clear: both;
    padding-top: 15px;

    table tbody tr {
        cursor: pointer;
    }

    tr.old {
        color: #a9a9a9;
    }

    .lesson-number {
        padding-right: 0 !important;
        color: #d5d5d5;
    }
}
.actions {
    .btn-delete {
        float: right;
    }
}
</style>
